// extracted by mini-css-extract-plugin
export default {"main":"TeamAction_main__AOgOL","icon":"TeamAction_icon__KgMrW","title":"TeamAction_title__NTfGv","text":"TeamAction_text__pF5ko"};